import React from 'react';

export const renderBoolean = (value?: boolean, dashForEmpty = true) => (
  <span>
    {value == null ? (dashForEmpty ? '-' : null) : value ? 'True' : 'False'}
  </span>
);
